import React from 'react';
import { Outlet, useParams } from 'react-router';
import MemberClientGuard from '../MemberClientGuard';
import { Notes } from '../Notes';
import { NotesProvider } from '../Notes/Context';

export const MemberProfileLayout: React.FC = () => {
  const { memberId } = useParams();

  return (
    <MemberClientGuard>
      <NotesProvider>
        <Outlet />
        {memberId && <Notes memberId={memberId} />}
      </NotesProvider>
    </MemberClientGuard>
  );
};
